import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadBedLayerSegments
export default function RBLSContent() {

    const tooltipRoadBedType = useAppSelector(state => state.mapTooltip.roadBedType)

    return (
        <>
            <div className="tooltip-info-row">Тип дорожной одежды: {tooltipRoadBedType ?? 'Не известен'}</div>
        </>
    )
}
